import Vue from 'vue'
import Vuex, {
    mapState
} from 'vuex'
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);
const state = {
    menuList: [], // 菜单列表
    route: [], // 路由信息
    customerReportList: [], // 自定义报表菜单,
    activeMenu: sessionStorage.getItem('activeSideMenuId') || '', // 当前激活的菜单,
    menuNewList: [], // 最新的菜单列表
    topMenuId: sessionStorage.getItem('BiTopMenuId') || '', // 顶部菜单id
    userInfo: null, // 登录信息
    collectList: [], // 常用报表列表
    tagOptions:[], // 标签选项
}
const modulesFiles = require.context('./modules', true, /\.js$/);
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath)
    modules[moduleName] = value.default
    return modules
}, {})


Vue.mixin({
    computed: {
        ...mapState('user', {
            isLogin: state => state.isLogin
        }),
        ...mapState({
            currentUserInfo: state => state.userInfo,
            currentPermission: state => state.userInfo.permissions,
            menuNewList: state => state.menuNewList,
        })
    }
})

const store = new Vuex.Store({
    state,
    modules,
    getters,
    mutations,
    actions
})

export default store